import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@tanstack/react-query'
import type {
  AgentAddUserBankAccountInput,
  AgentSetDefaultBankAccountInput,
  AgentGetBankAccountsInput,
} from '../api'
import type { IMutationArgs } from '../types'
import { userAgentBankGetOptions } from './agent-bank.options'
import userAgentBankService from './agent-bank.service'
import { EAgentBankQueryKey } from './agent-bank.types'

export const useCreateAgentBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AgentAddUserBankAccountInput) =>
      userAgentBankService.create(data),
    mutationKey: [EAgentBankQueryKey.CREATE],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EAgentBankQueryKey.GET] })
      return data
    },
  })
}

export const usePrefetchGetAgentBanks = (args: AgentGetBankAccountsInput) => {
  return useSuspenseQuery(queryOptions(userAgentBankGetOptions(args)))
}

export const useGetAgentBanks = (args: AgentGetBankAccountsInput) => {
  return useQuery(userAgentBankGetOptions(args))
}

export const useDeleteAgentBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: number[]) => userAgentBankService.remove(data),
    mutationKey: [EAgentBankQueryKey.DELETE],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EAgentBankQueryKey.GET] })
      return data
    },
  })
}

export const useSetDefaultAgentBank = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AgentSetDefaultBankAccountInput) =>
      userAgentBankService.setDefault(data),
    mutationKey: [EAgentBankQueryKey.SET_DEFAULT],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({ queryKey: [EAgentBankQueryKey.GET] })
      return data
    },
  })
}
